import React, {FC, useState} from "react";
import useSafeState from "../../utils/safe-state";
import {Trans} from "@lingui/macro";
import {Breadcrumb, Drawer, Tooltip} from "antd";
import {EyeOutlined, FileTextOutlined} from "@ant-design/icons/lib";
import DtoTable from "../../components/dto-table/dto-table";
import DdsRequirementModel from "../../models/ddsrequirements/dds-requirement-model";

const DdsRequirementsScreen: FC = () => {

    const [trigger, setTrigger] = useSafeState(false);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [responseDrawerVisible, setResponseDrawerVisible] = useState(false);
    const [selectedRequestBody, setSelectedRequestBody] = useState<string>("");
    const [selectedResponse, setSelectedResponse] = useState<string>("");

    const handleViewRequestBody = (record: any) => {
        setSelectedRequestBody(record.requestBody || "");
        setDrawerVisible(true);
    };

    const handleViewResponse = (record: any) => {
        setSelectedResponse(record.response || "");
        setResponseDrawerVisible(true);
    };

    const action = (record: any) => {
        return (
            <>
                {record.requestBody && (
                    <Tooltip title={<Trans>View Request Body</Trans>}>
                        <FileTextOutlined 
                            className={"ActionButtons"} 
                            style={{ fontSize: '18px', cursor: 'pointer', color: '#1890ff', marginRight: record.response ? '8px' : '0' }}
                            onClick={() => handleViewRequestBody(record)}
                        />
                    </Tooltip>
                )}
                {record.response && (
                    <Tooltip title={<Trans>View Response</Trans>}>
                        <EyeOutlined 
                            className={"ActionButtons"} 
                            style={{ fontSize: '18px', cursor: 'pointer', color: '#52c41a' }}
                            onClick={() => handleViewResponse(record)}
                        />
                    </Tooltip>
                )}
            </>
        )
    };

    const actions = {
        width: 150,
        render: (text: string, record: any) => action(record),
        title: <Trans>Actions</Trans>,
        fixed: 'right',
        align: 'center'
    };

    return (
        <>
            <Breadcrumb style={{marginBottom: 10}}>
                <Breadcrumb.Item><Trans id={'Home'}/></Breadcrumb.Item>
                <Breadcrumb.Item><Trans id={'DDS Requirements'}></Trans></Breadcrumb.Item>
            </Breadcrumb>
            
            <DtoTable
                model={DdsRequirementModel}
                trigger={trigger}
                allowRefreshButton={true}
                pageSize={100}
                scroll={{x: 1800, y: "65vh"}}
                action={actions}
            />

            <Drawer
                title={<Trans>Request Body</Trans>}
                placement="right"
                onClose={() => setDrawerVisible(false)}
                visible={drawerVisible}
                width={800}
            >
                <pre style={{ 
                    padding: '20px',
                    backgroundColor: '#fff',
                    border: '1px solid #f0f0f0',
                    borderRadius: '4px',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    fontFamily: 'ui-monospace, SFMono-Regular, monospace',
                    fontSize: '13px'
                }}>
                    {selectedRequestBody}
                </pre>
            </Drawer>

            <Drawer
                title={<Trans>Response</Trans>}
                placement="right"
                onClose={() => setResponseDrawerVisible(false)}
                visible={responseDrawerVisible}
                width={800}
            >
                <pre style={{ 
                    padding: '20px',
                    backgroundColor: '#fff',
                    border: '1px solid #f0f0f0',
                    borderRadius: '4px',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    fontFamily: 'ui-monospace, SFMono-Regular, monospace',
                    fontSize: '13px'
                }}>
                    {selectedResponse}
                </pre>
            </Drawer>
        </>
    )
}

export default DdsRequirementsScreen;

